module.exports = __WEBPACK_EXTERNAL_MODULE_132__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 132
// module chunks = 0